import { styled } from "@mui/system";
import { Popover } from "@mui/material";

const StyledPopover = styled(Popover)({});

export default StyledPopover;
